import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SideMenu from '../SideMenu';
import TopBar from '../TopBar';
import { El } from './style';
import { CLIMATE_CHECK_SLUG, COOL_FARM_SLUG, FARMER_ROLE_SLUG, MILK_STOCK_EXCHANGE } from '~/Constants';
import { useAuth } from '~/routes/components/AuthProvider';

export const IndicatorsContext = React.createContext(null);

const InnerContent: React.FunctionComponent = () => {
  const { systemData, systemData: { logged: { roleSlug } } } = useAuth()

  const hideTopAndSideMenu = Boolean(systemData.hideMenuAndHeader) && roleSlug === FARMER_ROLE_SLUG

  const [indicators, setIndicators] = useState([
    {
      key: 'co2-climate-check-indicator',
      value: 0
    },
    {
      key: 'newsletter-indicator',
      value: 0
    },
    {
      key: 'milk-fixed-price-indicator',
      value: 0
    },
    {
      key: 'survey-indicator',
      value: 0
    },
    {
      key: 'milk_fixed_price_fat_and_protein-indicator',
      value: 0
    },
    {
      key: `${MILK_STOCK_EXCHANGE}-indicator`,
      value: 0
    },
    {
      key: `${CLIMATE_CHECK_SLUG}-indicator`,
      value: 0
    },
    {
      key: `${COOL_FARM_SLUG}-indicator`,
      value: 0
    }
  ])

  return (
    <El.Wrapper>
      {!hideTopAndSideMenu && <TopBar />}
      <El.Container>
        <El.ContainerBox>
          <IndicatorsContext.Provider value={{ indicators, setIndicators }}>
            {!hideTopAndSideMenu && <SideMenu />}
            <Outlet />
          </IndicatorsContext.Provider>
        </El.ContainerBox>
      </El.Container>
    </El.Wrapper>
  );
};

export default InnerContent;
